import defineVueProperty from './defineVueProperty';
import * as formatter from '@/utils/formatter';

defineVueProperty('formatter', formatter);
